(function () {
    'use strict';

// @ngInject
    Models.HoneyTipModel = function HoneyTipModel(BaseModel) {

        return Class(BaseModel, {

            constructor: function HoneyTipModel() {
                this.constructor.$super.call(this);
                this.__className = 'HoneyTipModel';
            },

            mapChilds: function mapChilds() {
                return {};
            },

            afterMixingFrom: function afterMixingFrom(object) {
            },

            isCachable: function isCachable() {
                return false;
            }
        });
    };
}());

